import type { Observable as ObservableType } from 'rxjs/Observable';
import { gqlTagSwag } from '@atlassian/jira-software-swag/src/index.tsx';
import { mutation$ } from '@atlassian/jira-software-swag/src/services/mutation/index.tsx';

export const dismissModalOperationName = 'DismissFirstColumnMigrationModalBacklog';

export const dismissModalMutation = gqlTagSwag`
    mutation DismissFirstColumnMigrationModalBacklog($boardId: ID!) {
        dismissFirstColumnMigrationModal(input: {boardId: $boardId}) {
            boardScope {
                id
            }
        }
    }
`;

export const dismissMigrationModal = (baseUrl: string, boardId: string): ObservableType<void> =>
	mutation$<undefined>(baseUrl, dismissModalOperationName, dismissModalMutation, {
		boardId,
	});
